import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=c67e2bb2&scoped=true&"
import script from "./AnnouncementCard.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67e2bb2",
  null
  
)

export default component.exports